import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@alfresco/adf-core';
import { ContentModule } from '@alfresco/adf-content-services';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { PageLayoutModule } from '@alfresco/aca-shared';
import { WkAppSidenavModule } from '../../../components/sidenav/sidenav.module';
import { WkAppLayoutComponent } from './wk-app-layout/wk-app-layout.component';
import { WkAIComponent } from '../../../components/wk-ai/wk-ai.component';
import { EXPY_SIDEBAR_CLASS } from '../../../components/wk-ai/expy-sidebar.token';
import { ExpyChatSidebar } from '@wk/fab-expy-sdk';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    ContentModule,
    WkAppSidenavModule,
    HttpClientModule,
    PageLayoutModule,
  ],
  providers: [{ provide: EXPY_SIDEBAR_CLASS, useValue: ExpyChatSidebar }],
  declarations: [WkAppLayoutComponent, WkAIComponent],
  exports: [WkAppLayoutComponent, PageLayoutModule, WkAIComponent],
})
export class WkAppLayoutModule {}
